module.exports = __webpack_public_path__ + "img/sedan_driving.ca21bb35.svg";